
export const pad = function(num, size=2) {
    var s = String(num);
    while (s.length < size) {s = "0" + s;}
    return s;
};
